import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `}
`;


export const TimeMessageWrapper = styled.div`
  display: block;
  margin: 56px auto 0px;

  svg { 
    flex: 0 0 24px;
  }
`;

export const TimeMessage = styled.p`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;

    > span {
      width: fit-content;
      font-variant-numeric: tabular-nums;
    }
  `}
`;

export const QrCode = styled.img`
  height: 250px;
  width: 250px;
  margin: 56px auto 0px;
`;

export const CopyWrapper = styled.div`
  margin: 24px 0px 0px;
  width: 100%;
  
  button {
    max-width: 100%;
    svg {
      flex: 0 0 24px;
    }
  }
`;


export const Circle = styled.span`
  ${({
    theme,
  }) => css`
      align-items: center;
      background-color: ${theme.v2.colors.brand.primaryExtraDark};
      border-radius: 100%;
      color: ${theme.v2.colors.white.primary};
      display: flex;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.bold};
      height: 10px;
      justify-content: center;
      padding: 10px;
      width: 10px;
  `}
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style-type: none;
  margin: 24px 0px 0px;
  padding: 0px;
`;

export const ListITem = styled.li`
  ${({ theme }) => css`
    align-items: flex-start;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 8px;
    justify-content: flex-start;
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;
